export default function About() {
  return (
    <section id="about">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h2 className="section-title">Nosotros</h2>
            <div className="section-title-divider"></div>
            <p className="section-description text-center">
              Construyendo carreras exitosas en el mundo del modelaje webcam con profesionalismo y respeto.
            </p>
          </div>
        </div>
      </div>
      <div className="container about-container mt-5">
        <div className="row align-items-center">
          <div className="col-lg-6 about-img wow fadeInLeft">
            <img
              src="img/nosotros.webp"
              alt="Instalaciones de Afrodita Models en Armenia, Quindío"
              width={1600}
              height={1066}
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="col-lg-6 about-content wow fadeInRight" data-wow-delay="0.2s">
            <h3 className="about-title">Afrodita Models</h3>
            <p className="about-text">
              Con más de 4 años de trayectoria en Armenia, somos líderes en la formación de modelos webcam.
              Ofrecemos un entorno <b>seguro, profesional y respetuoso</b>, diseñado para que cada modelo
              alcance su máximo potencial financiero y personal.
            </p>
          </div>
        </div>

        <div className="row mt-5 align-items-center">
          <div className="col-lg-6 about-img order-lg-2 wow fadeInRight">
            <img
              src="img/1.webp"
              alt="Misión de Afrodita Models: empoderar a sus modelos"
              width={1600}
              height={1066}
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="col-lg-6 about-content order-lg-1 wow fadeInLeft" data-wow-delay="0.2s">
            <h3 className="about-title">Misión</h3>
            <p className="about-text">
              Nuestra misión es <b>empoderar</b> a nuestros modelos, proporcionando herramientas y
              formación constante para conquistar audiencias globales. Fomentamos un espacio inclusivo
              donde el crecimiento personal es nuestra mayor prioridad.
            </p>
          </div>
        </div>

        <div className="row mt-5 align-items-center">
          <div className="col-lg-6 about-img wow fadeInLeft">
            <img
              src="img/2.webp"
              alt="Visión de Afrodita Models: ser el referente nacional"
              width={1600}
              height={1066}
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="col-lg-6 about-content wow fadeInRight" data-wow-delay="0.2s">
            <h3 className="about-title">Visión</h3>
            <p className="about-text">
              Aspiramos a ser el referente nacional en la industria, <b>rompiendo estereotipos</b> y
              redefiniendo el entretenimiento a través de la excelencia, la innovación y el respeto
              absoluto por la diversidad.
            </p>
          </div>
        </div>

        <div className="row mt-5 align-items-center">
          <div className="col-lg-6 about-img order-lg-2 wow fadeInRight">
            <img
              src="img/3.webp"
              alt="Diversidad e inclusión en Afrodita Models"
              width={1600}
              height={1066}
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="col-lg-6 about-content order-lg-1 wow fadeInLeft" data-wow-delay="0.2s">
            <h3 className="about-title">Diversidad e Inclusión</h3>
            <p className="about-text">
              En Afrodita Models, la diversidad no se tolera, <b>se celebra</b>. Creemos que cada perspectiva única
              enriquece nuestra comunidad. Promovemos la igualdad de oportunidades y un ambiente donde
              todos son valorados por su autenticidad.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
